import React, { Component } from "react"
import * as ApiHelper from "../../ApiHelper"
import { LoadModal } from "../modais"
export default class RelatorioObjetoForm extends Component {
  constructor() {
    super()
    this.sendForm = this.sendForm.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }
  sendForm(event) {
    event.preventDefault()
    var params = {
      tipo_relatorio: "Objetos"
    }
    this.toggleLoadModal()
    ApiHelper.getRelatorioWith(params, relatorio => {
      this.toggleLoadModal()
      if (relatorio) {
        var url = URL.createObjectURL(relatorio)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute("download", "Objetos de contrato.pdf")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        console.log("Error")
      }
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  render() {
    return (
      <div className="row">
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <div className="row">
          <button
            onClick={this.sendForm}
            type="submit"
            className="btn btn-primary pull-left"
            data-background-color="as-blue"
          >
            Gerar
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/relatorios/RelatorioObjetoForm.js